/**
 * Getters for wordpress/themes module
 */
const getters = {
  all: state => state,
  json: state => JSON.stringify(state, null, 4)
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/themes/getters.js